import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EmptyStringValidator } from '@app/_helpers';
import { Signup } from '@app/_models/index';
import { SignupService, AlertService } from '@app/_services';
import { AppComponent } from '@app/app.component';


@Component({
  selector: 'app-free-background',
  templateUrl: './free-background.component.html',
  styleUrls: ['./free-background.component.less']
})
export class FreeBackgroundComponent implements OnInit {
  form: UntypedFormGroup;
  loading:boolean = false;
  submitted:boolean = false;
  emailInvalid:boolean = false;
  success:boolean = false;
  signup: Signup = new Signup();
  subscription: Subscription;


  constructor(private formBuilder: UntypedFormBuilder, 
    private signupService: SignupService, 
    private alertService: AlertService, 
    private appComponent: AppComponent) { 
    this.form = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern('^(?!-+$)[a-z A-Z -]+$'), EmptyStringValidator]],
      lastName: ['', [Validators.required, Validators.pattern('^(?!-+$)[a-z A-Z -]+$'), EmptyStringValidator]],
      companyName: ['', [Validators.required, EmptyStringValidator]],
      email: ['', [Validators.required, Validators.email]],
    })

    this.subscription = this.form.controls.email.valueChanges.subscribe((x: string) => {
      if (this.emailInvalid && (x.includes('.') || x.includes('@'))) this.emailInvalid = false;
    })
  }


  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.appComponent.application.hasFooter = false;
    this.appComponent.showHelpCenter = false;
    //chat service
    //window['embedded_svc'].settings.displayHelpButton = false;
  }


  handleEmailBlur() : void {
    this.emailInvalid = !this.form.controls.email.hasError('required') && this.form.controls.email.hasError('email');
    this.form.controls.email.markAsDirty();
  }

  onSubmit() : void {

    this.alertService.clear();
    
    if (this.form.invalid) {
      this.alertService.error("Please ensure the information you entered is correct");
    }

    this.loading = true;

    Object.keys(this.form.controls).forEach(x => {
      this.signup[x] = this.form.controls[x].value;
    })

    this.signupService.insertFreeBackgroundSMBClient(this.signup).subscribe(response => {
      if (response.error) {
        this.alertService.error(response.message, { autoClose: false })
      } else {
        this.subscription.unsubscribe();
        this.success = true;
      }
      this.loading = false;
    })
  }
}